import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsAccordionModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';
import { TranslateModule } from '@ngx-translate/core';

import { CmpsCommonModule } from '../../../common/common.module';
import { CmpsTooltipConditionalModule } from '../../detail/pillar-two/transcript-summary/tooltip-conditional.module';

import { CaEvaluationComponent } from './ca-evaluation.component';

@NgModule({
    declarations: [CaEvaluationComponent],
    exports: [CaEvaluationComponent],
    imports: [
        CmpsAccordionModule,
        CmpsCommonModule,
        CmpsIconModule,
        CmpsTooltipConditionalModule,
        CmpsTooltipModule,
        CommonModule,
        TranslateModule,
    ],
})
export class CmpsCaEvaluationModule {}
